import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TipoCartera } from '@p-p-portafolio/interfaces/tipoCartera';
import { TipoCarteraService } from '@p-p-portafolio/services/tipoCartera.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-tipoCartera-form',
  templateUrl: './tipoCartera-form.component.html',
  providers: [MessageService]
})
export class TipoCarteraFormComponent implements OnInit, OnChanges {
  @Input() model: TipoCartera | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private tipoCarteraService: TipoCarteraService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.loadTipoCartera();
      } else {
        this.initForm();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      sCartera: [{ value: '', disabled: !!this.model }, [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  loadTipoCartera(): void {
    if (!this.model) return;
    
    this.form.patchValue({
      sCartera: this.model.sCartera,
      descripcion: this.model.descripcion
    });
    this.form.get('sCartera')?.disable();
  }

  create(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 1,
      tope: '',
      clave: formData.sCartera,
      descripcion: formData.descripcion
    };

    this.tipoCarteraService.saveTipoCartera(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Tipo de cartera creado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.errors?.[0] || 'Error al crear el tipo de cartera'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear el tipo de cartera'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 2,
      tope: '',
      clave: formData.sCartera,
      descripcion: formData.descripcion
    };

    this.tipoCarteraService.updateTipoCartera(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Tipo de cartera actualizado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.errors?.[0] || 'Error al actualizar el tipo de cartera'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar el tipo de cartera'
        });
        this.loading = false;
      }
    });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'TipoCartera',
        sClave: `${this.form.get('sCartera')?.value}`,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }
}